// Character pixel widths for Arial at 20px (Google SERP Title font)
const ARIAL_20PX_WIDTHS = {
  ' ': 5.56, '!': 5.56, '"': 7.1, '#': 11.12, '$': 11.12, '%': 17.78, '&': 13.34,
  "'": 3.88, '(': 6.66, ')': 6.66, '*': 7.78, '+': 11.68, ',': 5.56, '-': 6.66,
  '.': 5.56, '/': 5.56, ':': 5.56, ';': 5.56, '<': 11.68, '=': 11.68, '>': 11.68,
  '?': 11.12, '@': 20.32, '[': 6.66, '\\': 5.56, ']': 6.66, '^': 11.68, '_': 11.12,
  '`': 6.66, '{': 6.66, '|': 5.1, '}': 6.66, '~': 11.68, '–': 11.12, '—': 20.0,
  '0': 11.12, '1': 11.12, '2': 11.12, '3': 11.12, '4': 11.12, '5': 11.12,
  '6': 11.12, '7': 11.12, '8': 11.12, '9': 11.12,
  'A': 13.34, 'B': 13.34, 'C': 14.44, 'D': 14.44, 'E': 13.34, 'F': 12.22, 'G': 15.56,
  'H': 14.44, 'I': 5.56, 'J': 10.0, 'K': 13.34, 'L': 11.12, 'M': 16.66, 'N': 14.44,
  'O': 15.56, 'P': 13.34, 'Q': 15.56, 'R': 14.44, 'S': 13.34, 'T': 12.22, 'U': 14.44,
  'V': 13.34, 'W': 18.88, 'X': 13.34, 'Y': 13.34, 'Z': 12.22,
  'Æ': 18.88, 'Ø': 15.56, 'Å': 13.34,
  'a': 11.12, 'b': 11.12, 'c': 10.0, 'd': 11.12, 'e': 11.12, 'f': 5.56, 'g': 11.12,
  'h': 11.12, 'i': 4.44, 'j': 4.44, 'k': 10.0, 'l': 4.44, 'm': 16.66, 'n': 11.12,
  'o': 11.12, 'p': 11.12, 'q': 11.12, 'r': 6.66, 's': 10.0, 't': 5.56, 'u': 11.12,
  'v': 10.0, 'w': 14.44, 'x': 10.0, 'y': 10.0, 'z': 10.0,
  'æ': 16.66, 'ø': 11.12, 'å': 11.12
};

export const MAX_TITLE_PX = 512;
export const MAX_DESCRIPTION_PX = 970;

/**
 * Calculate title pixel width in Arial 20px (Google Desktop SERP)
 */
export function getTitlePixelWidth(str = '') {
  let width = 0;
  for (const ch of String(str)) {
    if (ARIAL_20PX_WIDTHS[ch] !== undefined) {
      width += ARIAL_20PX_WIDTHS[ch];
    } else if (ch.toUpperCase() === ch && ch.toLowerCase() !== ch) {
      width += 13.34;
    } else {
      width += 10.0;
    }
  }
  return Math.round(width * 10) / 10;
}

/**
 * Calculate description pixel width in Arial 14px (Google Desktop SERP)
 * Arial 14px is 14/20 = 0.7 ratio of Arial 20px
 */
export function getDescriptionPixelWidth(str = '') {
  const width20 = getTitlePixelWidth(str);
  return Math.round(width20 * 0.7 * 10) / 10;
}

/**
 * Truncate a title so it never exceeds maxPx (default 512px)
 */
export function fitTitle(str = '', maxPx = MAX_TITLE_PX) {
  const s = String(str || '').trim();
  if (getTitlePixelWidth(s) <= maxPx) return s;

  let truncated = s;
  while (truncated.length > 0 && getTitlePixelWidth(truncated + '...') > maxPx) {
    truncated = truncated.slice(0, -1).trimEnd();
  }
  return truncated ? `${truncated}...` : s.slice(0, 45);
}

/**
 * Truncate a description so it never exceeds maxPx (default 970px)
 */
export function fitDescription(str = '', maxPx = MAX_DESCRIPTION_PX) {
  const s = String(str || '').trim();
  if (getDescriptionPixelWidth(s) <= maxPx) return s;

  let truncated = s;
  while (truncated.length > 0 && getDescriptionPixelWidth(truncated + '...') > maxPx) {
    // Try to cut at word boundary
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 30) {
      truncated = truncated.slice(0, lastSpace).trimEnd();
    } else {
      truncated = truncated.slice(0, -1).trimEnd();
    }
  }
  return truncated ? `${truncated}...` : s.slice(0, 140);
}
